import nProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router, { resetRouter } from '@/router'
import { useStore } from '@/store'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { PermissionMutationType } from '@/store/modules/permission/mutation-types'
import { permissionRoutes } from './index'

nProgress.configure({ showSpinner: false })

const store = useStore()
/* 动态的给路由添加权限 -- begin */
const getRt = (permissionList, name) => {
    let flag = ''
    const getSameRoute = (permissionList, name) => {
        permissionList.forEach(item => {
            if (item.name == name) {
                flag = item
            } else if (item.children && item.children.length) {
                getSameRoute(item.children, name)
            }
        })
    }
    getSameRoute(permissionList, name)
    return flag
}
const filterRouters = (routes) => {
    routes.forEach(item => {
        let sameRoute:any = getRt(JSON.parse(store.state.permission.dynamicRoutes), item.name)
        if (sameRoute) {
            item.meta.hasPermission = true
            item.meta.hidden = sameRoute.status ? false : true
            item.meta.actions = sameRoute.actions
        } else {
            item.meta.hasPermission = false
            item.meta.hidden = true
        }
        if (item.children && item.children.length) {
            filterRouters(item.children)
        }
    })
    return routes
}
/* 动态的给路由添加权限 -- end */

// 用户30分钟无操作退出登录
const checkCookieTime = () => {
    let lastCookieTime = parseInt(localStorage.getItem('last-cookie-time') || '')
    if (lastCookieTime && new Date().getTime() - lastCookieTime < 30 * 60 * 1000) {
        localStorage.setItem('last-cookie-time', new Date().getTime().toString())
    } else {
        localStorage.setItem('last-cookie-time', new Date().getTime().toString())
        // @ts-ignore
        store.dispatch(UserActionTypes.ACTION_LOGOUT)
        router.push(`/login`)
    }
}

router.beforeEach((to, from, next) => {
    const whitePaths = store.state.permission.whitePaths
    if (whitePaths.includes(to.path)) {
        next()
        nProgress.done()
    } else {
        if (store.state.user.userInfo.username) {
            if (to.path === '/login') {
                next({ path: '/' })
                nProgress.done()
            } else {
                checkCookieTime() // 验证登录是否过期
                const finalRoutes = filterRouters(permissionRoutes)
                store.commit(PermissionMutationType.SET_ROUTES, finalRoutes)
                localStorage.setItem('routes', JSON.stringify(finalRoutes))
                /* 解决页面刷新 meta 中的数据丢失的问题 -- begin */
                if (to.fullPath !== '/error/404') {
                    let sameRoute:any = getRt(JSON.parse(store.state.permission.dynamicRoutes), to.name)
                    if (sameRoute) {
                        to.meta.hasPermission = true
                        to.meta.hidden = sameRoute.status ? false : true
                        to.meta.actions = sameRoute.actions
                    }
                }
                /* 解决页面刷新 meta 中的数据丢失的问题 -- end */
                if (to.meta.hasPermission) {
                    next()
                    store.commit(UserMutationTypes.SET_CURRROUTE, to)
                    nProgress.done()
                } else {
                    next({ path: '/error/404' })
                    store.commit(UserMutationTypes.SET_CURRROUTE, to)
                    nProgress.done()
                }
            }
        } else {
            // next(`/login?redirect=${to.path}`)
            next(`/login`)
            nProgress.done()
        }
    }
})
